"use strict";

Shopify.theme.jsFeaturedBrandsList = {
  init: function init($section) {
    const featuredBrands = Window.theme.featured_brands_list.tiles;

    const groupedTiles = this.groupTilesByFirstLetter(featuredBrands);
    this.createDOMStructure(groupedTiles);
    this.accordionInit($section);

    // Media query change event to show/hide the accordions
    const mediaCondition = Shopify.media_queries.large;
    let isLarge = mediaCondition.matches;
    mediaCondition.addEventListener('change', () => {
      isLarge = event.matches;
      const $sectionHeader = $section.find('.js-list-category-header');
      const $sectionHeaderList = $sectionHeader.find('~ ul');
      if (isLarge) {
        // Open all accordions
        $sectionHeader.attr('aria-expanded', true);
        $sectionHeaderList.slideDown();
        $sectionHeaderList.attr('aria-hidden', false);
      } else {
        // Close all accordions
        $sectionHeader.attr('aria-expanded', false);
        $sectionHeaderList.slideUp();
        $sectionHeaderList.attr('aria-hidden', true);
      }
    });

    // Click for each anchor
    const sectionId = Window.theme.featured_brands_list.sectionId;
    $(document).on('click', '.js-navigation-link', function (e) {
      e.preventDefault();
      const letter = $(this).text();
      const $targetSection = $(`#${sectionId}-letter-${letter}`);
      if ($targetSection.length) {
        let stickyHeaderHeight = 0;

        if (Shopify.theme.jsHeader.enable_sticky && Shopify.theme_settings.header_layout !== 'vertical') {
          stickyHeaderHeight += Shopify.theme.jsHeader.getHeaderHeight();
        }

        if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky && Shopify.theme_settings.header_layout !== 'vertical') {
          stickyHeaderHeight += Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
        }

        const targetScrollPosition = $targetSection.offset().top - stickyHeaderHeight;
        $('html, body').animate({
          scrollTop: targetScrollPosition,
        }, 100);
      }
    });
  },
  // Initialize the accordion
  accordionInit: function($section) {
    if (!isScreenSizeLarge()) $section.find('.js-list-category-header ~ ul').attr('aria-hidden', true);
    const $lists = $section.find('.js-list-category-header');
    $lists.attr('aria-expanded', false);
    $lists.on('click', function (e) {
      e.preventDefault();
      if (!isScreenSizeLarge()) {
        const state = !!($(this).attr('aria-expanded') === 'false');
        $(this).attr('aria-expanded', state);
        $(this).next().slideToggle(() => {
          if ($(this).next().is(':visible')) {
            $(this).next().css('display','grid');
          }
        });
        $(this).next().attr('aria-hidden', !state);
      } else {
        $(this).attr('aria-expanded', true);
        $(this).next().attr('aria-hidden', false);
      }
    });
  },
  // Group tiles by alphabet and #
  groupTilesByFirstLetter: function(tiles) {
    return tiles.reduce((result, tile) => {
      const [firstLetter] = tile.title.trim().toUpperCase();
      const key = /[A-Z]/.test(firstLetter) ? firstLetter : '#';

      result[key] = result[key] || [];
      result[key].push(tile);

      return result;
    }, {});
  },
  // Replace the placeholder DOM with the newly generated DOM
  createDOMStructure: function(groupedTiles) {
    const $container = $('<div></div>');
    const $ul = $('<ul class="featured-brands-list__content"></ul>');
    const $headerNav = $('<div class="featured-brands-list__navigation"></div>');
    const sectionId = Window.theme.featured_brands_list.sectionId;

    Object.keys(groupedTiles).sort().forEach((letter) => {
      // Add links
      const $link = this.createNavigationLink(letter, sectionId);
      $headerNav.append($link);

      // Add list items
      const $listItem = $('<li class="featured-brands-list__category"></li>');
      const $header = this.createHeaderList(letter, groupedTiles[letter].length, sectionId);
      const $body = this.createList(groupedTiles[letter]);
      $listItem.append($header);
      $listItem.append($body);
      $ul.append($listItem);
    });

    const $featuredBrandsSection = $('.featured-brands-list');
    $featuredBrandsSection.empty();
    $container.append($headerNav);
    $container.append($ul);
    $container.appendTo($featuredBrandsSection);
  },
  // Create anchor links by passing in the letter and sectionId
  createNavigationLink: function(letter, sectionId) {
    return $('<a class="featured-brands-list__navigation-link js-navigation-link"></a>')
      .text(letter)
      .attr('href', `#${sectionId}-letter-${letter}`);
  },
  // Create each list's label and the number of items in the list
  createHeaderList: function(letter, tilesForLetterSize, sectionId) {
    const $buttonWrapper = $('<button type="button" class="featured-brands-list__category-header js-list-category-header"></button>')
    .attr('id', `${sectionId}-letter-${letter}`);

    const label = $('<span class="featured-brands-list__category-label js-list-category-label"></span>')
    .text(letter)
    .attr('id', `${sectionId}-letter-${letter}`);
    const count = $('<span class="featured-brands-list__category-count"></span>')
    .text(tilesForLetterSize);

    $buttonWrapper.append(label);
    $buttonWrapper.append(count);

    return $buttonWrapper;
  },
  // Create the brand's list
  createList: function(tiles) {
    const $ul = $('<ul class="featured-brands-list__body js-list-body"></ul>');

    tiles.forEach((tile) => {
      const $li = $('<li class="featured-brands-list__item"></li>');
      const $link = $('<a class="featured-brands-list__item-link"></a>')
      .text(tile.title)
      .attr('href', tile.url);

      $li.append($link);
      $ul.append($li);
    });
    return $ul;
  }
};
